import HK from 'factory/modules/HK';
import React from 'react';
import styles from '../../../static/css/MBCashNew/mbCash.module.scss'
import { convertToModule } from 'factory/utils/clientUtils';
export const isHkCashPage = () => {
    if (HK.getSearchParmas().tabId === "7" || window.location.href.indexOf('/reward') > -1){
        return true;
    } else {
        return false;
    }
}

export const TXN_STATUS = {
    DEBIT : 'Debit',
    CREDIT : 'Credit',
    EXPIRED : 'Expired',
}

export const TXN_STATUS_NM = {
    PENDING: 'Pending',
    APPROVED: 'Approved',
    REDEEMED: 'Redeemed',
    CANCELLED: 'Cancelled',
    EXPIRED: 'EXPIRED',
    APPROVED_REDEEMED: 'Approved Redeemed',
    TRANSFERRED: 'Transferred'
}

export const FAQS = [
    {
        q : 'How do I earn Gritzo Cash?',
        a : 'Gritzo Cash is earned automatically whenever a customer places an order by paying online.',
        id: 1,
    },
    {
        q : 'How much Gritzo Cash can I earn on purchase of a product? ',
        a : 'One can see that on individual product page or on cart page.',
        id: 2,
    },
    {
        q : 'I have placed my order, when will Gritzo Cash be credited to my account?',
        a : 'Once your order is successfully delivered and  has passed the 14-day return period, Gritzo Cash will be credited to your MuscleBlaze account. ',
        id: 3,
    },
    {
        q : 'What is the use of Gritzo Cash?',
        a : 'Once Gritzo Cash is credited to your MuscleBlaze account, you can immediately use that while placing your next order. Gritzo Cash is valid only on online payment modes i.e. Net banking, all Bank Debit & Credit Cards and Wallets.',
        id: 4,
    },
    {
        q : 'What Is The Validity Period Of Gritzo Cash Points? ',
        a : 'The validity period of Gritzo Cash is generally 90 days from the date of issue. Please check your Gritzo Cash email for the exact expiration date.',
        id: 5,
    },
]

export const cashIcon = (
    <img  className={convertToModule(styles,'icon')} src={HK.getImage('/ReferAndEarn/cash_icon.svg')} alt="gritzo-cash"/>
)